import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";

export default function Footer() {
  const { content, ui } = useSite();

  return (
    <footer className="border-t border-navy-border bg-navy-surface/50" data-testid="footer">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-6 py-10 sm:flex-row">
        <div className="flex items-center gap-3">
          <img src={content.logo} alt="D'Best Cleaning Services" className="h-10 w-auto rounded-lg" />
          <div>
            <p className="font-display text-lg uppercase tracking-wider text-white">D'Best Cleaning Services LLC</p>
            <p className="font-mono text-xs text-slate-500">Commercial & Residential · Rhode Island</p>
          </div>
        </div>
        <div className="flex items-center gap-6 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} D'Best Cleaning Services LLC. {ui.rights}</span>
          <Link to="/admin" data-testid="footer-admin-link" className="font-mono uppercase tracking-widest hover:text-volt">
            {ui.admin}
          </Link>
        </div>
      </div>
    </footer>
  );
}
